import React, { useContext, useEffect, useState } from "react";
import { RotatingLines } from 'react-loader-spinner';

const AuthCallback = () => {
	return (
		<div className='center'>
			Redirecting you to your dashboard
			<div className='center'>
				<RotatingLines
                	strokeColor="#152E54"
                    strokeWidth="3"
                    animationDuration="1.0"
                    width="48"
                    visible={true}
                />
			</div>
		</div>
	)
} 

export default AuthCallback;
